'use client';

import React, { useEffect, useRef } from 'react';
import { useCharacterData } from '../../../hooks/useGlobalChatState';
import { SidePanelContent } from '../../shared/SidePanel';
import '@/app/ui/scrollbar.css';

interface ProfilePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ProfilePanel({ isOpen, onClose }: ProfilePanelProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  const { character } = useCharacterData();

  // Handle panel close when clicking outside
  const handleBackdropClick = (event: React.MouseEvent) => {
    const target = event.target as Element;
    
    // Don't close if clicking on the panel content
    if (panelRef.current && panelRef.current.contains(target)) {
      return;
    }
    
    // Close if clicking on the backdrop
    onClose();
  };

  // Prevent body scroll when panel is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Don't render anything if no character
  if (!character) return null;

  return (
    <>
    {/* Profile Panel */}
      <div 
        className={`fixed inset-0 z-50 flex items-end bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={handleBackdropClick}
      >
        {/* Bottom-up panel */}
        <div
          ref={panelRef}
          className={`w-full bg-[#1a1a1e] rounded-t-[20px] flex flex-col transform transition-transform duration-300 ease-in-out ${
            isOpen ? 'translate-y-0' : 'translate-y-full'
          }`}
          style={{
            height: '80vh'
          }}
        >
          {/* Handle bar */}
          <div className="flex justify-center pt-4 pb-2 flex-shrink-0">
            <div className="w-12 h-1 bg-gray-600 rounded-full"></div>
          </div>
          
          {/* Panel content container */}
          <div className="flex-1 flex flex-col overflow-hidden">
            {/* Scrollable content area */}
            <div className="flex-1 overflow-y-auto dark-scrollbar px-6">
              <SidePanelContent onClose={onClose} />
            </div>
          </div>
        </div>
      </div>

    </>
  );
}